/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LoadingCapabilitiesAvailability = {
    Unknown: 'unknown',
    Yes: 'yes',
    No: 'no'
} as const;
export type LoadingCapabilitiesAvailability = typeof LoadingCapabilitiesAvailability[keyof typeof LoadingCapabilitiesAvailability];


export function instanceOfLoadingCapabilitiesAvailability(value: any): boolean {
    for (const key in LoadingCapabilitiesAvailability) {
        if (Object.prototype.hasOwnProperty.call(LoadingCapabilitiesAvailability, key)) {
            if (LoadingCapabilitiesAvailability[key as keyof typeof LoadingCapabilitiesAvailability] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LoadingCapabilitiesAvailabilityFromJSON(json: any): LoadingCapabilitiesAvailability {
    return LoadingCapabilitiesAvailabilityFromJSONTyped(json, false);
}

export function LoadingCapabilitiesAvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoadingCapabilitiesAvailability {
    return json as LoadingCapabilitiesAvailability;
}

export function LoadingCapabilitiesAvailabilityToJSON(value?: LoadingCapabilitiesAvailability | null): any {
    return value as any;
}

export function LoadingCapabilitiesAvailabilityToJSONTyped(value: any, ignoreDiscriminator: boolean): LoadingCapabilitiesAvailability {
    return value as LoadingCapabilitiesAvailability;
}

